import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { Caso } from './casos.model';
import { environment } from 'src/environments/environment';
import urlJoin from 'url-join';
import { ActivatedRoute } from "@angular/router";
import { NotificationsService } from '../core/service/notifications.service';
import { Incidencia } from './casos.model';

@Injectable({
  providedIn: 'root' // Poner aquí esta declaración hace que no sea necesario meterlo en providers de app.module
})
export class CasosService {

  private casosURL: string = urlJoin(environment.apiURL, 'expedientes')
  private variosURL: string = urlJoin(environment.apiURL, 'varios')

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService
  ) { }

  getCasos(): Observable<Caso[]> {
    return this.http.get<Caso[]>(this.casosURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  getCasosUsuario(id_usuario: string): Observable<Caso[]> {
    const casosUsuarioURL = `${this.casosURL}?id_usuario=${id_usuario}`;
    return this.http.get<Caso[]>(casosUsuarioURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  getCaso(id: string): Observable<any> {
    const getCasoURL = urlJoin(this.casosURL, id)
    return this.http.get<Caso>(getCasoURL)
      .pipe(
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  updateCaso(id: string, caso: Caso): Observable<any> {
    const updateCasoURL = urlJoin(this.casosURL, id)
    return this.http.put<Caso>(updateCasoURL, caso)
      .pipe(
        tap(() => {
          const updateCasoSuccessMessage: string = $localize `:@@updateCasoSuccessMessage:Caso modificado correctamente`;
          this.notificationsService.showSuccessNotification(updateCasoSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  deleteCaso(id: string): Observable<any> {
    const deleteCasoURL = urlJoin(this.casosURL, id)
    return this.http.delete<Caso>(deleteCasoURL)
      .pipe(
        tap(() => {
          const deleteCasoSuccessMessage: string = $localize `:@@deleteCasoSuccessMessage:Caso eliminado correctamente`;
          this.notificationsService.showSuccessNotification(deleteCasoSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  newCaso(caso: Caso): Observable<any> {
    const newCasoURL = urlJoin(this.casosURL)
    return this.http.post<Caso>(newCasoURL, caso)
      .pipe(
        tap(() => {
          const newCasoSuccessMessage: string = $localize `:@@newCasoSuccessMessage:Caso creado correctamente`;
          this.notificationsService.showSuccessNotification(newCasoSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  getIncidencias(): Observable<Incidencia[]> {
    let incidenciaURL = this.variosURL + "/incidencias";
    return this.http.get<Incidencia[]>(incidenciaURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error);
        })
      );
  }


}
